export default "__VITE_ASSET__CS1GcTGQ__"